import React from 'react';
import { Heading, IconCheck, IconCheckmark, IconCross } from '../../components';
import { FormattedMessage } from '../../util/reactIntl';
import { P } from '../PageBuilder/Primitives/P';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import css from './ListingPage.module.css';

const SectionSubjects = props => {
  const { intl, publicData } = props;
  const { subjectsDetails } = publicData || {};
  const classes = [5, 6, 7, 8, 9, 10, 11, 12, 13];
  return (
    subjectsDetails && (
      <section id="subjects" className={css.section}>
        <Heading as="h2" rootClassName={css.sectionHeading}>
          <FormattedMessage id="ListingPage.subjects" />
        </Heading>
        {/* <P className={css.sectionDescription}>
          <FormattedMessage id="ListingPage.subjectsDescription" />
        </P> */}
        <div className={css.sectionSubjectsContainer}>
          <Tabs focusTabOnClick={false}>
            <TabList>
              {subjectsDetails &&
                Object.keys(subjectsDetails).map(subject => {
                  return <Tab>{subject}</Tab>;
                })}
            </TabList>
            {!!subjectsDetails &&
              Object.keys(subjectsDetails).map(subject => {
                const subjectDetails = subjectsDetails?.[subject];
                return (
                  <TabPanel className={css.subjectTabPanel}>
                    <div className={css.subjectContainer}>
                      <Heading as="h2" rootClassName={css.subjectHeading}>
                        {subject}
                      </Heading>
                      {/* <P className={css.subjectDescription}>{subjectDetails.description}</P> */}
                    </div>
                    <div className={css.subjectDetailsMobile}>
                      <div className={css.subjectDetailsMobileContainer}>
                        {!!subjectDetails?.subjects &&
                          Object.keys(subjectDetails.subjects).map(schoolType => {
                            const schoolTypeClasses = subjectDetails.subjects?.[schoolType];
                            return (
                              <div className={css.subjectDetailColumn}>
                                {schoolType}
                                <div className={css.schoolTypeClasses}>
                                  {schoolTypeClasses.map(c => (
                                    <span
                                      className={css.classMobile}
                                      key={`${subject}.${schoolType}.${c}`}
                                    >
                                      <span>{c}</span>
                                      <IconCheckmark size="small" rootClassName={css.iconCheck} />
                                    </span>
                                  ))}
                                </div>
                              </div>
                            );
                          })}
                      </div>
                      <P className={css.subjectsNote}>
                        <FormattedMessage id="ListingPage.subjectsNote" />
                      </P>
                    </div>
                    <div className={css.subjectDetailsDesktop}>
                      <div className={css.subjectDetailRow}>
                        <div className={css.subjectDetailHeader}></div>
                        <div className={css.schoolTypeClasses}>
                          {classes.map(c => (
                            <span key={c}>{c}</span>
                          ))}
                        </div>
                      </div>
                      {!!subjectDetails?.subjects &&
                        Object.keys(subjectDetails.subjects).map(schoolType => {
                          const schoolTypeClasses = subjectDetails.subjects?.[schoolType];
                          return (
                            <div className={css.subjectDetailRow}>
                              <div className={css.subjectDetailHeader}>{schoolType}</div>
                              <div className={css.schoolTypeClasses}>
                                {classes.map(c => (
                                  <span key={`${subject}.${schoolType}.${c}`}>
                                    {schoolTypeClasses?.includes(c) ? (
                                      <IconCheckmark size="small" rootClassName={css.iconCheck} />
                                    ) : (
                                      <IconCross className={css.iconCross} />
                                    )}
                                  </span>
                                ))}
                              </div>
                            </div>
                          );
                        })}
                      <P className={css.subjectsNote}>
                        <FormattedMessage id="ListingPage.subjectsNote" />
                      </P>
                    </div>
                  </TabPanel>
                );
              })}
          </Tabs>
        </div>
      </section>
    )
  );
};

export default SectionSubjects;
